export const fullStack = [
    {
        id: 1,
        title: "E-Commerce App - MERN",
        image: "https://raw.githubusercontent.com/navneetkumar22/e_commerce_frontend/main/src/screenshots/screenshot.png",
        github: "https://github.com/navneetkumar22/ecommerce_project",
        live: "https://github.com/navneetkumar22/e_commerce_frontend"
    },
    {
        id: 2,
        title: "Todo App - MERN Stack",
        image: "https://raw.githubusercontent.com/navneetkumar22/todo_app_jwt/main/frontend/src/screenshots/Screenshot2.png",
        github: "https://github.com/navneetkumar22/todo_app_jwt",
        live: "https://todo-app-jwt.netlify.app"
    },
    {
        id: 3,
        title: "CRUD App - React",
        image: "https://raw.githubusercontent.com/navneetkumar22/crud_express_react/main/Screenshot.png",
        github: "https://github.com/navneetkumar22/crud_express_react",
        live: "https://playful-begonia-09bdc5.netlify.app/"
    },
    {
        id: 4,
        title: "CRUD App - Vanilla JS",
        image: "https://raw.githubusercontent.com/navneetkumar22/crud_app_fetchApi/main/Screenshot.png",
        github: "https://github.com/navneetkumar22/crud_app_fetchApi",
        live: "https://crud-fetchapi.netlify.app"
    }
]

export const htmlCss = [
    {
        id: 0,
        title: "iNeuron Clone Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/placement_assignment_navneetkumar_cssq11/main/screenshot/screenshot.png",
        github: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_cssq11",
        live: "https://ineuron-clone-navneetkumar.netlify.app"
    },
    {
        id: 1,
        title: "Periodic Table",
        image: "https://raw.githubusercontent.com/navneetkumar22/placement_assignment_navneetkumar_periodic_table/main/screenshot/screenshot1.png",
        github: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_periodic_table",
        live: "https://periodictable-navneetkumar.netlify.app"
    },
    {
        id: 2,
        title: "Product Design Landing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/15.png",
        github: "https://github.com/navneetkumar22/Product_Design_Landing_Page",
        live: "https://navneet-project15.netlify.app"
    },
    {
        id: 3,
        title: "Dance Home Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/14.png",
        github: "https://github.com/navneetkumar22/Dance_Home_page",
        live: "https://navneet-project14.netlify.app"
    },
    {
        id: 4,
        title: "SAAS Landing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/13.png",
        github: "https://github.com/navneetkumar22/Saas_Landing_Page",
        live: "https://navneet-project13.netlify.app"
    },
    {
        id: 5,
        title: "Business Landing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/12.png",
        github: "https://github.com/navneetkumar22/Business_Landing_Page",
        live: "https://navneet-project12.netlify.app"
    },
    {
        id: 6,
        title: "Hosting Landing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/11.png",
        github: "https://github.com/navneetkumar22/Hosting_Landing_Page",
        live: "https://navneet-project11.netlify.app"
    },
    {
        id: 7,
        title: "Interior Design Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/10.png",
        github: "https://github.com/navneetkumar22/Interior_Design_Page",
        live: "https://navneet-project10.netlify.app/"
    },
    {
        id: 8,
        title: "Developer Landing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/9.png",
        github: "https://github.com/navneetkumar22/Developer_Landing_page",
        live: "https://navneet-project09.netlify.app"
    },
    {
        id: 9,
        title: "Web Design Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/8.png",
        github: "https://github.com/navneetkumar22/Web_Design_Page",
        live: "https://navneet-project08.netlify.app"
    },
    {
        id: 10,
        title: "Product Home Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/7.png",
        github: "https://github.com/navneetkumar22/Product_Home_Page",
        live: "https://navneet-project07.netlify.app"
    },
    {
        id: 11,
        title: "Plant Home Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/6.png",
        github: "https://github.com/navneetkumar22/Plant_Home_Page",
        live: "https://navneet-project06.netlify.app"
    },
    {
        id: 12,
        title: "Crypto Landing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/5.png",
        github: "https://github.com/navneetkumar22/Crypto_Landing_Page",
        live: "https://navneet-project05.netlify.app"
    },
    {
        id: 13,
        title: "Digital Marketing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/4.png",
        github: "https://github.com/navneetkumar22/digital_marketing_page",
        live: "https://navneet-project04.netlify.app"
    },
    {
        id: 14,
        title: "Law Home Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/3.png",
        github: "https://github.com/navneetkumar22/Law_home_page",
        live: "https://navneet-project03.netlify.app"
    },
    {
        id: 15,
        title: "Food Restaurant Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/2.png",
        github: "https://github.com/navneetkumar22/Food_Restaurant_page",
        live: "https://navneet-project02.netlify.app"
    },
    {
        id: 16,
        title: "Street Style Landing Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/streetstylepage/main/screenshot.png",
        github: "https://github.com/navneetkumar22/streetstylepage",
        live: "https://navneet-project01.netlify.app/"
    },
]

export const tailwind = [
    {
        id: 1,
        title: "Paytm Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/paytm.png",
        github: "https://github.com/navneetkumar22/Paytm_Clone_tailwind",
        live: "https://navneet-paytm.netlify.app"
    },
    {
        id: 2,
        title: "RØDE Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/rode.png",
        github: "https://github.com/navneetkumar22/Rode_Clone_tailwind",
        live: "https://navneet-rode.netlify.app"
    },
    {
        id: 3,
        title: "Shopify Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/portfolio/master/thumbnails/shopify.png",
        github: "https://github.com/navneetkumar22/Shopify_Clone_tailwind",
        live: "https://navneet-shopify.netlify.app"
    },
]

export const reactJS = [
    {
        id: 1,
        title: "Todo App - MERN Stack",
        image: "https://raw.githubusercontent.com/navneetkumar22/todo_app_jwt/main/frontend/src/screenshots/Screenshot2.png",
        github: "https://github.com/navneetkumar22/todo_app_jwt",
        live: "https://todo-app-jwt.netlify.app"
    },
    {
        id: 2,
        title: "Shopping Cart App",
        image: "https://raw.githubusercontent.com/navneetkumar22/shopping_cart_react/main/src/screenshot/products_page.png",
        github: "https://github.com/navneetkumar22/shopping_cart_react",
        live: "https://shoppingcart-project.netlify.app"
    },
    {
        id: 3,
        title: "Theme Toggler App",
        image: "https://raw.githubusercontent.com/navneetkumar22/placement_assignment_navneetkumar_reactq9/main/src/screenshot/light.png",
        github: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq9",
        live: "https://theme-switcher-navneetkumar.netlify.app"
    },
    {
        id: 4,
        title: "Task Manager App",
        image: "https://raw.githubusercontent.com/navneetkumar22/placement_assignment_navneetkumar_reactq16/main/screenshot/tasks.png",
        github: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq16",
        live: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq16"
    },
    {
        id: 5,
        title: "Calculator Application",
        image: "https://raw.githubusercontent.com/navneetkumar22/placement_assignment_navneetkumar_reactq13/main/src/Screenshot.png",
        github: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq13",
        live: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq13"
    },
    {
        id: 6,
        title: "Counter Application",
        image: "https://raw.githubusercontent.com/navneetkumar22/placement_assignment_navneetkumar_reactq12/main/src/Screenshot.png",
        github: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq12",
        live: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq12"
    },
    {
        id: 7,
        title: "Todo Application",
        image: "https://raw.githubusercontent.com/navneetkumar22/placement_assignment_navneetkumar_reactq11/main/src/sceenshot/screenshot.png",
        github: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq11",
        live: "https://github.com/navneetkumar22/placement_assignment_navneetkumar_reactq11"
    },
    {
        id: 8,
        title: "CRUD Application",
        image: "https://raw.githubusercontent.com/navneetkumar22/crud_express_react/main/Screenshot.png",
        github: "https://github.com/navneetkumar22/crud_express_react",
        live: "https://playful-begonia-09bdc5.netlify.app/"
    },
    {
        id: 9,
        title: "TicTacToe Game",
        image: "https://raw.githubusercontent.com/navneetkumar22/tic_tac_toe/main/src/Screenshot1.png",
        github: "https://github.com/navneetkumar22/tic_tac_toe",
        live: "https://reactjstic-tac-toe.netlify.app"
    },
]

export const vanillaJS = [
    {
        id: 1,
        title: "Accordian Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/01Accordion/Screenshot1.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/01Accordion",
        live: "https://accordian-page.netlify.app"
    },
    {
        id: 2,
        title: "Case conversion Page",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/02NameConversion/Screenshot2.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/02NameConversion",
        live: "https://case-conversion-js.netlify.app"
    },
    {
        id: 3,
        title: "Color Changer",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/03ColorChanger/Screenshot3.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/03ColorChanger",
        live: "https://color-changerjs.netlify.app"
    },
    {
        id: 4,
        title: "Password Generator",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/04PasswordGenerator/Screenshot4.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/04PasswordGenerator",
        live: "https://passwd-generator-js.netlify.app"
    },
    {
        id: 5,
        title: "Rock Paper Scissor",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/05RockPaperScissor/Screenshot5.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/05RockPaperScissor",
        live: "https://rockpaper-scissor-js.netlify.app"
    },
    {
        id: 6,
        title: "Jokes Generator",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/06JokesGenerator%20-%20API/Screenshot6.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/06JokesGenerator%20-%20API",
        live: "https://jokes-genrator.netlify.app"
    },
    {
        id: 7,
        title: "QR Code Generator",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/07QRCodeGenerator%20-%20API/Screenshot7.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/07QRCodeGenerator%20-%20API",
        live: "https://qrcode-generatorjs.netlify.app"
    },
    {
        id: 8,
        title: "Age Calculator",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/08Age-Calculator/Image/Screenshot8.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/08Age-Calculator",
        live: "https://jsage-calculator.netlify.app"
    },
    {
        id: 9,
        title: "See What You Type",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/09SeeWhatYouType/Image/Screenshot9.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/09SeeWhatYouType",
        live: "https://see-what-you-typejs.netlify.app"
    },
    {
        id: 10,
        title: "Basic Counter",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/10BasicCounter/Image/Screenshot10.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/10BasicCounter",
        live: "https://basic-counterjs.netlify.app"
    },
    {
        id: 11,
        title: "Todo Application",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/12Todo/Image/Screenshot12.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/12Todo",
        live: "https://todo-apps-js.netlify.app"
    },
    {
        id: 12,
        title: "Binary to Decimal",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/13Binary2Decimal/Image/Screenshot13.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/13Binary2Decimal",
        live: "https://binary-2-decimal-js.netlify.app"
    },
    {
        id: 13,
        title: "Quiz Application",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/14JsQuizApp/Image/Screenshot14-1.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/14JsQuizApp",
        live: "https://quiz-apps-js.netlify.app"
    },
    {
        id: 14,
        title: "Basic Calculator",
        image: "https://raw.githubusercontent.com/navneetkumar22/JavaScript_Assignments/master/15Calculator/Image/Screenshot15-1.png",
        github: "https://github.com/navneetkumar22/JavaScript_Assignments/tree/master/15Calculator",
        live: "https://basic-calculatorjs.netlify.app"
    },
    {
        id: 15,
        title: "CRUD App - Vanilla JS",
        image: "https://raw.githubusercontent.com/navneetkumar22/crud_app_fetchApi/main/Screenshot.png",
        github: "https://github.com/navneetkumar22/crud_app_fetchApi",
        live: "https://crud-fetchapi.netlify.app"
    }
]

export const funWithDom = [
    {
        id: 1,
        title: "Fun with DOM",
        image: 'https://raw.githubusercontent.com/navneetkumar22/Fun_with_DOM_Assignments/master/images/thumbnail.png',
        github: "https://github.com/navneetkumar22/Fun_with_DOM_Assignments",
        live: "https://github.com/navneetkumar22/Fun_with_DOM_Assignments"
    }
]